import { render, staticRenderFns } from "./TypographyCss.vue?vue&type=template&id=328b12e8&"
import script from "./TypographyCss.vue?vue&type=script&lang=ts&"
export * from "./TypographyCss.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports